// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"386":"d57eaec3","491":"dcf49717","787":"ca822a80","941":"23d48df1"}[chunkId] + ".chunk.js";
};